export const paymentType = {
    RECEIPT: "Пополнение счёта",
    CHANGE_BALANCE: "Изменение баланса Администрацией",
    LESSON: "Списание средств за урок",
    RETURN_LESSON: "Возврат средств за урок",
}